document.addEventListener("DOMContentLoaded", function () {
  const stickyCart = document.getElementById("sticky-add-to-cart");

  if (!stickyCart) return;

  // Oculta inicialmente
  stickyCart.classList.add("hidden");

  window.addEventListener("scroll", function () {
    const scroll = window.scrollY || document.documentElement.scrollTop;

    if (scroll > 1200) {
      stickyCart.classList.remove("hidden");
    } else {
      stickyCart.classList.add("hidden");
    }
  });
});
